import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'antd';
import FormField from '../molecules/FormField';
import CustomInputField from '../atoms/CustomInputField';
import CustomButton from '../atoms/CustomButton';
import { SalesButton, Title } from './LoginFormStyle';
import { useSelector } from 'react-redux';

const LoginForm = ({ onSubmit }) => {
  const [userType, setUserType] = useState('admin');
  const loginState = useSelector((state) => state.loginState);
  const [form] = Form.useForm();

  const handleUserTypeChange = (value) => {
    form.resetFields();
    setUserType(value);
  };

  const handleSubmit = (values) => {
    onSubmit({ ...values, type: userType });
  };
  const style = {
    background: '#0092ff',
    padding: '8px 0',
  };
  return (
    <Card bordered={false} style={{ width: 500 }}>
      <Title>Sign In</Title>
      <Form layout='vertical' onFinish={handleSubmit} name='normal_login' initialValues={{}} form={form}>
        <FormField
          label='User Name'
          name='username'
          rules={[{ required: true, message: 'Please input your user name!' }]}
        >
          <CustomInputField
            type='text'
            placeholder={
              userType === 'admin' ? 'Admin User Name' : userType === 'sales' ? 'Sales User Name' : 'Purchase User Name'
            }
            size='large'
          />
        </FormField>
        <FormField
          label='Password'
          name='password'
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <CustomInputField type='password' placeholder='Password' size='large' />
        </FormField>

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <CustomButton
              type='primary'
              htmlType='submit'
              size='large'
              disabled={loginState.status === 'loading'}
              block
            >
              Login
            </CustomButton>
          </Col>
          <Col span={8}>
            <CustomButton type='primary' size='large' onClick={() => handleUserTypeChange('admin')} block>
              Admin
            </CustomButton>
          </Col>
          <Col span={8}>
            <SalesButton type='primary' size='large' onClick={() => handleUserTypeChange('sales')} block danger>
              Sales
            </SalesButton>
          </Col>
          <Col span={8}>
            <CustomButton type='primary' size='large' onClick={() => handleUserTypeChange('purchase')} block>
              Purchase
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default LoginForm;
